import { SxProps } from '@mui/material';

export const ContainerSx: SxProps = {
  width: '100%',
  height: '100%',
};

export const TableContainerSx: SxProps = {
  width: '100%',
  minHeight: '400px',
  marginTop: 0,
};

export const SearchContainerSx: SxProps = {
  padding: '8px 16px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)'
};

export const SearchFieldSx: SxProps = {
  width: '300px'
};

export const TableTitleSx: SxProps = {
  fontWeight: 500
};

export const AssetLinkSx: SxProps = {
  fontWeight: 'bold',
  textDecoration: 'underline',
}; 
